/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V3 API
 * OpenAPI spec version: 3.0.0
 */

export type V3CustomerAddressEntitlementStatus = typeof V3CustomerAddressEntitlementStatus[keyof typeof V3CustomerAddressEntitlementStatus];


export const V3CustomerAddressEntitlementStatus = {
  approved: 'approved',
  pending_approval: 'pending_approval',
  pending_removal: 'pending_removal',
  rejected: 'rejected',
  removed: 'removed',
} as const;
